import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { Solution } from '../../common/types/solution';

interface SolutionsState {
  solutions: Solution[];
  loading: boolean;
  error: string | null;
}

const initialState: SolutionsState = {
  solutions: [],
  loading: false,
  error: null,
};

const solutionsSlice = createSlice({
  name: 'solutions',
  initialState,
  reducers: {
    setSolutions: (state, action: PayloadAction<Solution[]>) => {
      state.solutions = action.payload;
      state.error = null;
    },
    setSolutionsLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setSolutionsError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.solutions = [];
    },
  },
});

export const { setSolutions, setSolutionsLoading, setSolutionsError } = solutionsSlice.actions;

// Selectors
export const selectSolutions = (state: RootState) => state.solutions.solutions;
export const selectSolutionsLoading = (state: RootState) => state.solutions.loading;
export const selectSolutionsError = (state: RootState) => state.solutions.error;

export default solutionsSlice.reducer;
